require('../styles/modules/about.scss');
import React, { Component, PropTypes } from 'react'
class About extends Component {

  render() {
    return (
      <div className = 'about'>
        <h2>
          About The Game
        </h2>
          <p> Once upon a time there were four robots - Red, Green, Yellow and Blue. Sometimes robots break and they need to go home to get rebooted.</p>
          <p> Robots are dumb so they need your help to guide them home. Robots are also clumsy so they <strong>can only go in straight lines</strong> and <strong>cannot stop until they hit a wall or another robot</strong>. </p>
          <p> Robots also value efficiency so the less you move them the happier they will be.</p>
        <h2>
          Controls
        </h2>
          <p><strong> Desktop </strong></p>
          <ul>
            <li>Select Robot - Click on the robot OR press tab</li>
            <li>Deselect Robot - Click anywhere on the game board except on the robot or its direction lines</li>
            <li>Move Selected Robot - Click on a direction line OR use the direction pad</li>
          </ul>
          <p><strong> Mobile </strong></p>
          <ul>
            <li>Select Robot - Tap on the robot OR click on a colored square</li>
            <li>Deselect Robot - Click anywhere on the game board except on the robot or its direction lines</li>
            <li>Move Selected Robot - Click on a direction line OR swipe to a direction on the game board</li>
          </ul>
        <h2>
          Daily Challenge
        </h2>
        <p>
          Compete against others in our <a href='/challenge'>daily challenge</a>! Can you find the most efficient solution to all the puzzles?
        </p>
        <p>
          There will be new puzzles every day, starting at <strong>Noon PDT</strong>.
        </p>
        <p>
          You can see how well you are doing compared to others in the <a href='/highscore'>highscore section</a>.
        </p>
        <h2>
          Questions Or Feedback
        </h2>
        <p>
          If you have any questions or feedback about the game please contact me at @asakurasol on twitter.
        </p>
        <p> I am working very actively on the game but that also means stuff will break every once in a while, just let me know if you notice anything.</p>
        <h2>
          Credits
        </h2>
        <p><a href="https://en.wikipedia.org/wiki/Alex_Randolph">Alex Randolph</a> for designing the original game.</p>
        <p><a href="http://sdtsui.com/2015/04/06/ricochet-robots-ii/">Daniel Tsui</a> for the technical know-how on the board background</p>
        <p><a href="https://thenounproject.com/arsenty/collection/bots/">Arsentry</a> for the robot arts</p>
        <p>...and of course my family and friends who supported me along the way =D</p>
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./containers/About.js